module.exports = __webpack_public_path__ + "img/red.ee2796d4.svg";